import * as PickstarUserAnalytics from '@pickstar/user-analytics'

export default {
  getTrackingUser (user, slug, isVlast = false) {
    if (user.role && user.role.includes('Admin')) {
      return new PickstarUserAnalytics.V2.AdminUser(
        this.getPlatform(slug, isVlast),
        user.id,
        user.name,
        user.email,
        this.getUserType(user.role),
        this.getSegment(),
        this.getRegion(user),
        this.getUserSubType(user.role)
      )
    } else {
      return new PickstarUserAnalytics.V2.StandardUser(
        this.getPlatform(slug, isVlast),
        user.id,
        user.name,
        user.email,
        this.getUserType(user.role),
        this.getSegment(),
        this.getRegion(user)
      )
    }
  },
  getPlatform (slug, isVlast) {
    return new PickstarUserAnalytics.V2.Platform(
      isVlast ? PickstarUserAnalytics.V2.PlatformType.VLAST_DASHBOARD : PickstarUserAnalytics.V2.PlatformType.PICKSTAR_DASHBOARD,
      1.0, // TODO: check for the right value - e.g. in mobile app, this is the app version
      slug
    )
  },
  getUserType (role) {
    if (role && role.includes('Admin')) {
      role = 'admin'
    }

    switch (role.toLowerCase()) {
      case 'admin':
        return PickstarUserAnalytics.V2.UserType.ADMIN
      case 'client':
        return PickstarUserAnalytics.V2.UserType.CLIENT
      case 'manager':
        return PickstarUserAnalytics.V2.UserType.MANAGER
      case 'talent':
        return PickstarUserAnalytics.V2.UserType.TALENT
      default:
        return PickstarUserAnalytics.V2.UserType.UNKNOWN
    }
  },
  getUserSubType (role) {
    if (role && role.includes('Admin')) {
      switch (role.toLowerCase()) {
        case 'regional-admin':
          return PickstarUserAnalytics.V2.AdminUserSubType.REGION
        case 'super-regional-admin':
          return PickstarUserAnalytics.V2.AdminUserSubType.SUPER_REGION
        case 'restricted-admin':
          return PickstarUserAnalytics.V2.AdminUserSubType.RESTRICTED
        case 'reporting-admin':
          return PickstarUserAnalytics.V2.AdminUserSubType.REPORTING
        default:
          return PickstarUserAnalytics.V2.AdminUserSubType.UNKNOWN
      }
    }

    return undefined
  },
  getSegment () {
    return null // TODO: need to figure out
  },
  getRegion (user) {
    if (user.region && user.region.shortname) {
      switch (user.region.shortname.toLowerCase()) {
        case 'uk':
          return PickstarUserAnalytics.V2.UserRegion.GB
        default:
          return PickstarUserAnalytics.V2.UserRegion.AU
      }
    }

    return undefined
  }
}
